import {Tabs} from 'antd';
import React from 'react';

import {IDirectoryEntityMeta} from 'entities/metadata';

import {DirectoryEmptyDataPlaceholder} from '../empty-data-placeholder/empty-data-placeholder';
import {DirectoryFormItem} from './directory-form-item';

export interface IDirectoryFormItemContainerProps {
    url: string;
    metadata: IDirectoryEntityMeta;
    currentTab: string | undefined;
    data?: Record<string, any>[];
    setCurrentTab: (tab: string) => void;
}

export const DirectoryFormItemContainer = ({
    setCurrentTab, currentTab, metadata, url, data,
}: IDirectoryFormItemContainerProps) => (
    <div className="directory-tabs">
        {data && data.length > 0
            ? (
                <Tabs
                    tabPosition="left"
                    onChange={tab => {
                        setCurrentTab(tab);
                    }}
                    destroyInactiveTabPane
                    defaultActiveKey={currentTab}
                >
                    {data.map(entry => (
                        <Tabs.TabPane
                            className="directory-form-tab-content"
                            tab={entry[metadata.titleField || 'id'] as string}
                            key={entry[metadata.linkField || 'id'] as string}
                        >
                            <DirectoryFormItem
                                url={url}
                                data={entry}
                                metadata={metadata}
                                referenceUrl={`${metadata.name}/${currentTab}`}
                            />
                        </Tabs.TabPane>
                    ))}
                </Tabs>
            )
            : <DirectoryEmptyDataPlaceholder />}
    </div>
);
